/** @jsxImportSource @emotion/react */
import PersonIcon from '@mui/icons-material/Person'
import { Card, CardContent, Typography, useTheme, Box } from '@mui/material'
import { cardTitle, metricCard } from '../styles/Admin.styles'

interface TotalUsersCardProps {
  count: number
  title: string
}

export const AdminConfirmedUsersCard = ({ count, title }: TotalUsersCardProps) => {
  const theme = useTheme()

  return (
    <Card css={metricCard()}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 1,
          }}
        >
          <Typography variant="subtitle2" css={cardTitle}>
            {title}
          </Typography>

          <PersonIcon
            sx={{
              color: theme.palette.success.main,
              fontSize: 28,
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} css={cardTitle}>
          {count ?? '-'}
        </Typography>

        <Typography variant="body2" color="text.secondary">
          Users who have access to Rex for this client
        </Typography>
      </CardContent>
    </Card>
  )
}
